






































import { FileUpload } from "@/models";
import { Component, Vue, Prop } from "vue-property-decorator";
import MediumProgress from "@/models/MediumProgress";
import FormatNumber from "@/filters/FormatNumber";
import DateTime from "@/filters/DateTime";

@Component({ filters: { FormatNumber, DateTime } })
export default class MediumProgressItem extends Vue {
  @Prop({ required: true }) readonly mediumProgress!: MediumProgress;
  @Prop({ required: true }) readonly fileUpload!: FileUpload;

  get importDate() {
    return this.fileUpload.createdAt;
  }

  get mediumName() {
    return this.mediumProgress.broadcasterName;
  }

  get hasError() {
    return this.mediumProgress.status === "failed";
  }

  get status() {
    return this.mediumProgress.status;
  }

  get progress() {
    return (this.mediumProgress.progress || 0) * 100;
  }

  get progressStyled() {
    return { width: `${Number(this.progress).toFixed(2)}%` };
  }

  get errors() {
    return this.mediumProgress.errors;
  }
}
